<template>
    <div>
        <q-table
            ref="table"
            :data="events"
            :columns="columns"
            row-key="id"
            @request="requestEvents"
            :loading="loading"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[5,10,50,100]"
            binary-state-sort
            class="q-mt-lg"
            >

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <template slot="body" slot-scope="props">
                <q-tr :props="props">
                    <q-td key="first_event_date" :props="props">
                        {{ fDate(props.row.first_event_date) }}
                    </q-td>

                    <q-td key="event_type" :props="props">
                        {{ getEventType(props.row.event_type) }}
                    </q-td>

                    <q-td key="test_type" :props="props">
                        {{ getTestType(props.row.test_type) }}
                    </q-td>

                    <q-td key="platform" :props="props">
                        {{ getPlatformType(props.row.platform, props.row.event_type) }}
                    </q-td>

                    <q-td key="status" :props="props" auto-width>
                        <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width text-center">
                            {{ $t(getTextStatus(props.row.status)) }}
                        </q-chip>
                    </q-td>

                    <q-td auto-width key="actions" :props="props">
                        <q-btn flat round color="secondary" icon="fas fa-chalkboard-teacher" @click="showEventUsers(props.row)" >
                            <q-tooltip>
                                {{ $t('participants_report_tooltip') }}
                            </q-tooltip>
                        </q-btn>

                        <q-btn flat round color="secondary" icon="fas fa-file-signature" @click="showEventTests(props.row)" >
                            <q-tooltip>
                                {{ $t('tests_report_tooltip') }}
                            </q-tooltip>
                        </q-btn>
                    </q-td>
                </q-tr>
            </template>
        </q-table>

        <event :show_event_report="show_event_report" :event="event_id" @hide_event_report="hideEventReport()" />

        <event-users v-if="show_event_users" :show_event_users="show_event_users" :id="id" :event_id="event_id" :load="true" :permissions="permissions" @hide_event_report="hideEventReport()" />

        <event-tests v-if="show_event_tests" :show_event_tests="show_event_tests" :id="id" :event_id="event_id" :load="true" :permissions="permissions" @hide_event_report="hideEventReport()" />
    </div>
</template>

<script>
import Event from 'components/admin/presential/report/Event.vue'
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
    name: 'AdminPresentialReportEvents',

    props: ['load', 'id', 'permissions'],

    components: {
        'event': Event,
        'event-users': () => import('components/admin/presential/report/EventUsers.vue'),
        'event-tests': () => import('components/admin/presential/report/EventTests.vue')
    },

    data() {
        return {
            columns: [
                {
                    name: 'first_event_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'first_event_date',
                    sortable: false,
                },
                {
                    name: 'event_type',
                    required: true,
                    label: 'event_type',
                    align: 'left',
                    field: 'event_type',
                    sortable: false,
                },
                {
                    name: 'test_type',
                    required: true,
                    label: 'test',
                    align: 'left',
                    field: 'test_type',
                    sortable: false,
                },
                {
                    name: 'platform',
                    required: true,
                    label: 'platform',
                    align: 'left',
                    field: 'platform',
                    sortable: false,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: false,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'left',
                    field: 'actions',
                    sortable: false,
                }
            ],
            events: [],
            event_test_types: [
                { type: 'no_test', value: 1, label: this.$t('no_test') },
                { type: 'presential_test', value: 2, label: this.$t('presential_test') },
                { type: 'online_test', value: 3, label: this.$t('online_test') }
            ],
            loading: false,
            event_id: null,
            show_event_report: false,
            show_event_users: false,
            show_event_tests: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
            live_class_platform_types: 'registration_lists/live_class_platform_types',
            num_rows: 'datatable/num_rows',
            webcast_types: 'registration_lists/webcast_types'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        requestEvents() {
            this.loading = true

            this.$axios.get(`/presential/presential_events/${this.id}/reports/event_dates/`, this.getHeader)
            .then((response) => {

                console.log(response.data)
                this.events = response.data.results.map(e => {
                    return {
                        first_event_date: e.event_date,
                        event_type: e.presential_event_date_type,
                        test_type: e.has_test,
                        platform: e.live_class ? e.live_class.platform_type : !e.live_class && e.webcast ? e.webcast.webcast_type : !e.webcast && e.platform_live_class ? e.platform_live_class : 1,
                        actions: e.id }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        getEventType(ev) {
            switch (ev) {
                case 1:
                    return this.$t('presential')
                case 2:
                    return this.$t('webcast')
                case 3:
                    return this.$t('live_class')
                default:
                    return ''
            }
        },

        getTestType(test) {
            const testType = this.event_test_types.find(t => test === t.value)
            if (testType) return testType.label
            else return null
        },

        getPlatformType(platform, type) {
            if (type === 3) {
                if (this.live_class_platform_types) {
                    return this.live_class_platform_types.find(t => t.value === platform).label
                }
            }
            else if (type === 2)  {
                if (this.webcast_types) {
                    return this.webcast_types.find(t => t.value === platform).label
                }
            }
            else return ''
        },

        getTextStatus(status) {
            if (status === 1) return 'published'
            else if (status === 2) return 'unpublished'
            else return 'finished'
        },

        getColorStatus(status) {
            if (status === 1) return 'primary'
            else if (status === 2) return 'warning'
            else return 'positive'
        },

        getIconStatus(status) {
            if (status === 1) return 'fas fa-check'
            else if (status === 2) return 'fas fa-times'
            else return 'fas fa-check'
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY'
                    break
                    default: format = 'MM-DD-YYYY'
                    break
                }

                return moment(d).tz('Etc/GMT').format(format)
            }
        },

        savePaginationInputs() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.pagination.rowsPerPage])
        },

        loadPagination() {
            this.pagination.rowsPerPage = this.num_rows
        },

        showEventUsers(event) {
            this.event_id = event.actions
            this.show_event_users = true
        },

        showEventTests(event) {
            this.event_id = event.actions
            this.show_event_tests = true
        },

        showEvent(event) {
            this.event_id = event.actions
            this.show_event_report = true
        },

        hideEventReport() {
            this.show_event_report = false
            this.show_event_users = false
            this.show_event_tests = false
            this.event_id = null
        }
    },

    watch: {
        load: function() {
            if (this.load) {
                this.requestEvents()
            }
        }
    },

    created() {
        this.requestEvents()
    }
}
</script>

<style>

</style>
